"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Org model module.
 * @module model/Org
 * @version 0.2.0
 */
var Org = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Org</code>.
   * @alias module:model/Org
   */
  function Org() {
    _classCallCheck(this, Org);

    Org.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Org, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Org</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Org} obj Optional instance to populate.
     * @return {module:model/Org} The populated <code>Org</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Org();

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }

        if (data.hasOwnProperty('last_update_ts')) {
          obj['last_update_ts'] = _ApiClient["default"].convertToType(data['last_update_ts'], 'String');
        }

        if (data.hasOwnProperty('labels')) {
          obj['labels'] = _ApiClient["default"].convertToType(data['labels'], 'String');
        }

        if (data.hasOwnProperty('group_name')) {
          obj['group_name'] = _ApiClient["default"].convertToType(data['group_name'], 'String');
        }

        if (data.hasOwnProperty('group_id')) {
          obj['group_id'] = _ApiClient["default"].convertToType(data['group_id'], 'String');
        }

        if (data.hasOwnProperty('vas_id')) {
          obj['vas_id'] = _ApiClient["default"].convertToType(data['vas_id'], 'String');
        }
      }

      return obj;
    }
  }]);

  return Org;
}();
/**
 * @member {String} id
 */


Org.prototype['id'] = undefined;
/**
 * @member {String} name
 */

Org.prototype['name'] = undefined;
/**
 * Optional latest value from the organizations data
 * @member {String} last_update_ts
 */

Org.prototype['last_update_ts'] = undefined;
/**
 * Pipe-delimited labels to add to the dropdown.
 * @member {String} labels
 */

Org.prototype['labels'] = undefined;
/**
 * @member {String} group_name
 */

Org.prototype['group_name'] = undefined;
/**
 * Optional ID for group of orgs. When displaying, the list is grouped by the \"group_name\" to allow for different grouping criteria in the future.
 * @member {String} group_id
 */

Org.prototype['group_id'] = undefined;
/**
 * @member {String} vas_id
 */

Org.prototype['vas_id'] = undefined;
var _default = Org;
exports["default"] = _default;